<template>
  <Teleport
    to="#teleports"
  >
    <dialog
      v-if="visible"
      v-bind="$attrs"
      :open="visible"
      :class="computedClasses"
    >
      <slot />
    </dialog>
  </Teleport>
</template>

<script setup lang="ts">
const props = defineProps<{
  hasPriority?: boolean
}>()

const visible = defineModel<boolean>('visible', { default: false })

defineOptions({
  inheritAttrs: false,
})

const showBackground = ref(false)
const showContent = ref(false)

watch(visible, (newValue) => {
  if (newValue) {
    showBackground.value = true
    showContent.value = true
  }
}, { immediate: true })

const computedClasses = computed(() => {
  return [
    'fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent text-primary-950',
    props.hasPriority ? 'z-[10001]' : 'z-[10000]',
  ]
})
</script>
